import React from 'react';

const Mainpage = () => {
  return (
    <div className="flex justify-center items-center ">
      <img
        src="https://media.istockphoto.com/id/1303877287/vector/paper-checklist-and-pencil-flat-pictogram.jpg?s=612x612&w=0&k=20&c=NoqPzn94VH2Pm7epxF8P5rCcScMEAiGQ8Hv_b2ZwRjY=" // Replace with your image URL
        alt="Sample"
        className="w-100 h-100 object-cover" // Fixed width and height
      />
    </div>
  );
};

export default Mainpage;
